import { ActionReducerMap } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import { routerReducer } from '@ngrx/router-store';

export interface RootState {
    router: fromRouter.RouterReducerState<any>;
}

export const reducers: ActionReducerMap<RootState> = {
    router: routerReducer
};
